import React from 'react';

import classNames from 'classnames';

import './index.scss';

const MutateTasksListLegend = ({ comonent: Component = 'div', ...props }) => (
  <Component
    {...props}
    className={classNames(
      'mutate-tasks-list-legend',
      // eslint-disable-next-line react/destructuring-assignment
      props.className,
    )}
  >
    {/* eslint-disable-next-line react/destructuring-assignment */}
    {props.children}
  </Component>
);

export default MutateTasksListLegend;
